var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"absolute":_vm.absolute,"opacity":_vm.opacity,"z-index":_vm.zIndex}},[_c('div',{staticClass:"container"},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white","size":50,"width":"2"}}):_vm._e(),_c('br'),_c('h1',{staticClass:"message-color"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }